import { memo } from "react";
import styled from "styled-components";
import color from "../../../helpers/color";
import textSize from "../../../helpers/textSize";
const Header = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Header",
  componentId: "sc-1jzg010-0"
})(["", " color:", ";font-weight:600;"], textSize, color));
Header.displayName = "Header";
Header.defaultProps = {
  color: "text"
};
export default Header;
//# sourceMappingURL=index.js.map